module.exports = __webpack_public_path__ + "static/img/seller.4661c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/seller.png
// module id = 6RUX
// module chunks = 1